<template>
    <div class="container">
            <div ref="chartContainer"></div>
    </div>
</template>
  
  
<script>
import Highcharts from 'highcharts';

export default {
    name: 'incomeChart',
    components: {
    },
    data() {
        return {
            incomeData: [
                { year_1: "2055", year_2: "3199", year_3: "9988", year_4: "16638", year_5: "14122", year_6: "11114", year_7: "15943", year_8: "15741", year_9: "15157" }   // รายได้
            ],
        };
    },
    methods: {
    },
    async mounted() {
        this.incomeData = [
            parseFloat(this.incomeData[0]?.year_1),
            parseFloat(this.incomeData[0]?.year_2),
            parseFloat(this.incomeData[0]?.year_3),
            parseFloat(this.incomeData[0]?.year_4),
            parseFloat(this.incomeData[0]?.year_5),
            parseFloat(this.incomeData[0]?.year_6),
            parseFloat(this.incomeData[0]?.year_7),
            parseFloat(this.incomeData[0]?.year_8),
            parseFloat(this.incomeData[0]?.year_9),
        ];

        Highcharts.chart(this.$refs.chartContainer, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
            {
                    name: 'รายได้',
                    data: this.incomeData.map((value, index) => ({
                        y: value,
                        color: index === 8 ? '#E87D2E' : '#414042',
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });
    }


};
</script>

 
  
  